module.exports = __webpack_public_path__ + "img/logo_square_color.4b1db1d3.png";